import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=33f33a89&scoped=true&"
import script from "./magazine.vue?vue&type=script&lang=ts&"
export * from "./magazine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f33a89",
  null
  
)

export default component.exports